
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire050c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire050c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4OuRQ", function(module, exports) {
module.exports = import("5sCpJ").then(()=>parcelRequire('i0lBz'));

});

parcelRegister("2ELLk", function(module, exports) {
module.exports = Promise.all([
    import("5sCpJ"),
    import("6OVoQ")
]).then(()=>parcelRequire('1Mfal'));

});

function $b4e14b6b8da86996$var$convertRemToPixels(rem) {
    return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}


async function $b4e14b6b8da86996$var$initParticles(containerId) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error('[Particles] Container not found:', containerId);
        return null;
    }
    const [{ tsParticles: tsParticles }, { loadSlim: loadSlim }] = await Promise.all([
        (parcelRequire("4OuRQ")),
        (parcelRequire("2ELLk"))
    ]);
    await loadSlim(tsParticles);
    await tsParticles.load({
        id: containerId,
        options: {
            fullScreen: {
                enable: false
            },
            particles: {
                move: {
                    enable: true
                },
                number: {
                    value: 50
                },
                opacity: {
                    value: {
                        min: 0.3,
                        max: 1
                    }
                },
                shape: {
                    type: [
                        "circle",
                        "square",
                        "triangle",
                        "polygon"
                    ],
                    options: {
                        polygon: [
                            {
                                sides: 5
                            },
                            {
                                sides: 6
                            },
                            {
                                sides: 8
                            }
                        ]
                    }
                },
                size: {
                    value: {
                        min: 1,
                        max: 3
                    }
                },
                color: {
                    value: [
                        '#cfd3dc',
                        '#b9bfd3',
                        '#9aa0b5'
                    ]
                },
                links: {
                    enable: true,
                    color: "#cfd3dc"
                }
            }
        }
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    // Track Mouse.
    const radius = $b4e14b6b8da86996$var$convertRemToPixels(20);
    document.querySelectorAll('.track-mouse').forEach((el)=>{
        // If element is svg.
        if (el.tagName.toLowerCase() === 'svg') {
            const grad = el.querySelector('radialGradient');
            document.addEventListener('mousemove', (e)=>{
                const rect = el.getBoundingClientRect();
                const x = (e.clientX - rect.left) / rect.width * 100;
                const y = (e.clientY - rect.top) / rect.height * 100;
                if (grad) {
                    grad.setAttribute('fx', `${x}%`);
                    grad.setAttribute('fy', `${y}%`);
                    grad.setAttribute('cx', `${x}%`);
                    grad.setAttribute('cy', `${y}%`);
                }
            });
            return;
        }
        document.addEventListener('mousemove', (e)=>{
            if (!el.offsetParent) return; // Skip if not visible
            const rect = el.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            if (x < -radius || x > rect.width + radius || y < -radius || y > rect.height + radius) return; // Skip if out of bounds with margin
            el.style.setProperty('--mouse-x', `${x}px`);
            el.style.setProperty('--mouse-y', `${y}px`);
        });
    });
    document.querySelectorAll('nav .burger').forEach((burger)=>{
        burger.addEventListener('click', ()=>{
            const nav = burger.closest('nav').querySelector('.nav-links');
            if (nav) nav.classList.toggle('open');
        });
    });
    document.querySelectorAll('.hoverRubberBand').forEach((el)=>{
        el.addEventListener('mouseover', ()=>{
            el.classList.add('animated', 'rubberBand');
        });
        el.addEventListener('animationend', ()=>{
            el.classList.remove('animated', 'rubberBand');
        });
    });
    if (window.innerWidth > 1120) {
        $b4e14b6b8da86996$var$initParticles('particles-left').catch((err)=>{
            console.error('[Particles] Failed to init left particles:', err);
        });
        $b4e14b6b8da86996$var$initParticles('particles-right').catch((err)=>{
            console.error('[Particles] Failed to init right particles:', err);
        });
    }
});


//# sourceMappingURL=camus.fun.3fa62952.js.map
